import { useState } from "react";
import Posts from "../Posts";
import { IoSearchOutline } from "react-icons/io5";
import './index.css'

const Tranasctions = () => {
    let componentsArr = [];
    for (let i = 0; i <= 200; i++) {
      componentsArr.push(<Posts key={i} />);
    }

    const [currentPage, setCurrentPage] = useState(1)
    const recordsPerPage = 20;
    const lastIndex = currentPage * recordsPerPage;
    const firstIndex = lastIndex - recordsPerPage;
    const records = componentsArr.slice(firstIndex, lastIndex);
    const nPages = Math.ceil(componentsArr.length/recordsPerPage);
    const numbers = [...Array(nPages+1).keys()].slice(1)

    const prePage = () => {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }

    const nxtPage = () => {
        if (currentPage !== nPages) {
            setCurrentPage(currentPage + 1)
        }
    }

    const changeCPage = id => {
        setCurrentPage(id)
    }

    return (
        <div className='tranasctions-container'>
            <div className='search-trans-container'>
                <div className='search-box'>
                    <IoSearchOutline className="search-icon-1" />
                    <input type="search" placeholder="Search by order ID..." className="search-bar-1" />
                </div>
                <div className="sort-container">
                    <div className="sort-box">
                        <span>Sort</span>
                        <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704784866/icon_20_eecb5f.svg" />
                    </div>
                    <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704784866/icon_21_lo5kc6.svg" className="download-image" />
                </div>
            </div>
            <div className="top-bar-container">
                <span className="menu-para">Order ID</span>
                <span className="menu-para">Order date
                <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704784898/icon_24_cwp8lm.svg" className="bar-icon" />
                </span>
                <span className="menu-para">Order amount</span>
                <span className="menu-para">Transaction fees
                <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704784897/icon_22_khoxg6.svg" className="bar-icon" />
                </span>
            </div>
            {records}
            <div className="pagination-container">
                <button className="button" onClick={prePage}>
                    <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704790831/icon_25_hpwtfb.svg" />
                    Previous
                </button>
                <ul className="pagination-list">
                    {numbers.map((n,i) => (
                        <li className="page-link" key={i}>
                            <a href="#" className={`page-item-${currentPage === n ? 'active' : ''}`} onClick={() => changeCPage(n)}>{n}</a>
                        </li>
                    ))}
                </ul>
                <button className="button" onClick={nxtPage}>
                    Next
                    <img src="https://res.cloudinary.com/dk7um3syw/image/upload/v1704790831/icon_26_mag7u3.svg" />
                </button>
            </div>
        </div>
    )
}

export default Tranasctions
